import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import { UsuariosService } from '../services';

const CORES = ['#2563eb', '#7c3aed', '#16a34a', '#dc2626', '#d97706', '#0891b2', '#db2777', '#0f172a'];

export default function Perfil() {
  const { usuario, updateUsuario } = useAuth();
  const [form, setForm] = useState({ nome: '', email: '', avatar_cor: '#2563eb', moeda: 'BRL' });
  const [senhaForm, setSenhaForm] = useState({ senha_atual: '', nova_senha: '', confirmar: '' });
  const [loading, setLoading] = useState(false);
  const [senhaLoading, setSenhaLoading] = useState(false);
  const [sucesso, setSucesso] = useState('');
  const [erro, setErro] = useState('');
  const [erroSenha, setErroSenha] = useState('');
  const [sucessoSenha, setSucessoSenha] = useState('');

  useEffect(() => {
    if (usuario) setForm({ nome: usuario.nome, email: usuario.email, avatar_cor: usuario.avatar_cor || '#2563eb', moeda: usuario.moeda || 'BRL' });
  }, [usuario]);

  const handlePerfil = async (e) => {
    e.preventDefault(); setLoading(true); setErro(''); setSucesso('');
    try {
      const data = await UsuariosService.atualizarPerfil(form);
      updateUsuario(data);
      setSucesso('Perfil atualizado com sucesso!');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar');
    } finally { setLoading(false); }
  };

  const handleSenha = async (e) => {
    e.preventDefault(); setErroSenha(''); setSucessoSenha('');
    if (senhaForm.nova_senha !== senhaForm.confirmar) {
      setErroSenha('As senhas não coincidem'); return;
    }
    if (senhaForm.nova_senha.length < 6) {
      setErroSenha('A nova senha deve ter pelo menos 6 caracteres'); return;
    }
    setSenhaLoading(true);
    try {
      await UsuariosService.alterarSenha({ senha_atual: senhaForm.senha_atual, nova_senha: senhaForm.nova_senha });
      setSucessoSenha('Senha alterada com sucesso!');
      setSenhaForm({ senha_atual: '', nova_senha: '', confirmar: '' });
    } catch (err) {
      setErroSenha(err.response?.data?.erro || 'Erro ao alterar senha');
    } finally { setSenhaLoading(false); }
  };

  const initials = form.nome?.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase() || 'U';

  return (
    <Layout title="Meu Perfil">
      <div style={{ maxWidth: 600, margin: '0 auto' }}>

        {/* Avatar */}
        <div className="card mb-3">
          <div className="card-body" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <div style={{ width: 70, height: 70, borderRadius: '50%', background: form.avatar_cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 26, fontWeight: 700, color: 'white', flexShrink: 0 }}>
              {initials}
            </div>
            <div>
              <h3 style={{ fontSize: 18, fontWeight: 600 }}>{form.nome}</h3>
              <p className="text-muted" style={{ fontSize: 13 }}>{form.email}</p>
              <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                {CORES.map(c => (
                  <button key={c} onClick={() => setForm(p => ({ ...p, avatar_cor: c }))}
                    style={{
                      width: 24, height: 24, borderRadius: '50%', background: c, border: `3px solid ${form.avatar_cor === c ? 'white' : 'transparent'}`,
                      outline: form.avatar_cor === c ? `2px solid ${c}` : 'none', cursor: 'pointer'
                    }} />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Dados pessoais */}
        <div className="card mb-3">
          <div className="card-header"><span className="card-title">👤 Dados Pessoais</span></div>
          <form onSubmit={handlePerfil}>
            <div className="modal-body" style={{ padding: 20 }}>
              {erro && <div className="alert alert-danger">{erro}</div>}
              {sucesso && <div className="alert alert-success">{sucesso}</div>}
              <div className="form-group">
                <label className="form-label">Nome completo</label>
                <input className="form-control" value={form.nome} required
                  onChange={e => setForm(p => ({ ...p, nome: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">E-mail</label>
                <input type="email" className="form-control" value={form.email} required
                  onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Moeda</label>
                <select className="form-control" value={form.moeda} onChange={e => setForm(p => ({ ...p, moeda: e.target.value }))}>
                  <option value="BRL">BRL — Real Brasileiro</option>
                  <option value="USD">USD — Dólar Americano</option>
                  <option value="EUR">EUR — Euro</option>
                </select>
              </div>
            </div>
            <div className="modal-footer" style={{ padding: '0 20px 20px' }}>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Salvando...' : 'Salvar Alterações'}
              </button>
            </div>
          </form>
        </div>

        {/* Alterar senha */}
        <div className="card">
          <div className="card-header"><span className="card-title">🔐 Alterar Senha</span></div>
          <form onSubmit={handleSenha}>
            <div className="modal-body" style={{ padding: 20 }}>
              {erroSenha && <div className="alert alert-danger">{erroSenha}</div>}
              {sucessoSenha && <div className="alert alert-success">{sucessoSenha}</div>}
              <div className="form-group">
                <label className="form-label">Senha atual</label>
                <input type="password" className="form-control" required value={senhaForm.senha_atual}
                  onChange={e => setSenhaForm(p => ({ ...p, senha_atual: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Nova senha</label>
                <input type="password" className="form-control" required minLength={6} value={senhaForm.nova_senha}
                  onChange={e => setSenhaForm(p => ({ ...p, nova_senha: e.target.value }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Confirmar nova senha</label>
                <input type="password" className="form-control" required value={senhaForm.confirmar}
                  onChange={e => setSenhaForm(p => ({ ...p, confirmar: e.target.value }))} />
              </div>
            </div>
            <div className="modal-footer" style={{ padding: '0 20px 20px' }}>
              <button type="submit" className="btn btn-primary" disabled={senhaLoading}>
                {senhaLoading ? 'Alterando...' : 'Alterar Senha'}
              </button>
            </div>
          </form>
        </div>

      </div>
    </Layout>
  );
}
